module.exports = __webpack_public_path__ + "img/img_head2x.ad87fa52.png";